import { render, staticRenderFns } from "./TeacherTiers.vue?vue&type=template&id=5b4753f4&"
import script from "./TeacherTiers.vue?vue&type=script&lang=js&"
export * from "./TeacherTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports